'use client';
export {
  FocusScope,
  FocusScopeBranchProvider,
  useFocusScopeBranchRegistry,
  useFocusScopeBranch,
  //
  Root,
} from './focus-scope';
export type {
  FocusScopeProps,
  FocusScopeBranchProviderProps,
  FocusScopeBranchRegistry,
} from './focus-scope';
